import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'erp-order-list',
  name: '客户订单',
  icon: '单',
  group: 'ERP 组件',
  description: '展示通用订单中心中的 ERP 客户订单。',
  defaultProps: {
    title: '客户订单',
    limit: 5
}
}
